// components/portal/useNoticeAcknowledgement.ts
'use client';

import { useKernel } from '@/kernel/Kernel';
import { useKernelStore } from '@/kernel/kernelStores';
import { acknowledgedNoticeIds } from '#lib/noticeAcknowledgements';

export const useNoticeAcknowledgement = (noticeId: string) => {
  const { kernel } = useKernel();
  const userId = useKernelStore((state) => state.userContext.dbUserId);
  const ready = useKernelStore((state) => !!state.userContext.dbUserId && state.userPreferencesOwnerId === state.userContext.dbUserId);
  const accepted = useKernelStore((state) => state.userPreferencesOwnerId === state.userContext.dbUserId
    && acknowledgedNoticeIds(state.userPreferences).includes(noticeId));

  const accept = () => {
    const k = kernel.current;
    if (!ready || !k || k.getUserContext().dbUserId !== userId) return;
    const ids = acknowledgedNoticeIds(k.getUserPreferences());
    if (!ids.includes(noticeId)) void k.updateAndSaveUserPreference('acknowledgedNoticeIds', [...ids, noticeId]);
  };

  return { ready, accepted, accept };
};
